import {OfferInfo} from "~/app/core/model/offer-info";

export class OfferThumbnailInfo {
    id: number;
    name: string;
    company: string;
    image: string;
    location: string;
    isFavorite: boolean;
    isWebOffer: boolean;
    offer: OfferInfo;
}
